window.initInfoTabs ?? (() => {
  window.initInfoTabs = (section_id) => {
  const infoTabs = document.querySelectorAll(`section#shopify-section-${section_id} .careline-info-tabs .info-tab`);
  const infoTabContainers = document.querySelectorAll(`section#shopify-section-${section_id} .careline-info-tabs .info-tab-container`);

  const infoTabsArrowPrev = document.querySelector(`section#shopify-section-${section_id} .careline-info-tabs .tabs-button.tab-button-prev`);
  const infoTabsArrowNext = document.querySelector(`section#shopify-section-${section_id} .careline-info-tabs .tabs-button.tab-button-next`);

  if(!infoTabs || !infoTabContainers) {
    return false;
  }

  const showActiveTab = (ev) => {
    let tab = ev.currentTarget;
    if(tab.classList.contains('active')) {
      return false;
    }
    let tabScroller = tab.closest('.info-tabs-scroller');
    
    tabScroller.querySelectorAll('.info-tab').forEach(thisTab => {
        if(thisTab == tab) {
          thisTab.classList.add('active');
        } else {
          thisTab.classList.remove('active');
        }
    });
    
    infoTabContainers.forEach(tabContainer => {
        if(tabContainer.dataset.id == tab.dataset.id) {
          tabContainer.classList.add('active');
        } else {
          tabContainer.classList.remove('active');
        }
    });
  }

  const scrollToTab = () => {
    document.querySelector(`section#shopify-section-${section_id} .careline-info-tabs .info-tab.active`).scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest' 
    });
  }

  const showPrevActiveTab = (ev) => {
    if(document.querySelector(`section#shopify-section-${section_id} .careline-info-tabs .info-tab.active`).previousElementSibling) {
      document.querySelector(`section#shopify-section-${section_id} .careline-info-tabs .info-tab.active`).previousElementSibling.click();
      scrollToTab(); 
    } 
  }

  const showNextActiveTab = (ev) => {
    if(document.querySelector(`section#shopify-section-${section_id} .careline-info-tabs .info-tab.active`).nextElementSibling) {
      document.querySelector(`section#shopify-section-${section_id} .careline-info-tabs .info-tab.active`).nextElementSibling.click();
      scrollToTab();    
    }
  }

  infoTabs.forEach(tab => {
    tab.addEventListener('click', showActiveTab);
  });

  infoTabsArrowPrev.addEventListener('click', showPrevActiveTab);
  infoTabsArrowNext.addEventListener('click', showNextActiveTab);
  
}
})();